var console = window.console;

// Cookie Dialog
var cookieSettings = new BootstrapCookieConsentSettings();

jQuery (function ($) {

    // manually shoe cookie dialog when cookie button is selected
    $('#manual-cookie-settings').on( 'click', function() {
        cookieSettings.showDialog()
    });

    $("#dropdown-button").on("click", function(){
        if($("#dropdown-menu").css("display") == "none"){
            $("#dropdown-button span").css("background-image", "url('http://"+window.location.host+"/wp-content/themes/itk-lws/images/Close.svg')")

        }else{
            $("#dropdown-button span").css("background-image", "url('http://"+window.location.host+"/wp-content/themes/itk-lws/images/Hamburger.svg')")
        }


        $("#dropdown-menu").slideToggle(500)
    })

    $(".open-purchase-menu").on("click", function() {
        // $("#ribbon:visible").slideToggle(500);
        $("#purchase-menu:hidden").slideToggle(500);
    })

    $("#purchase-arrow").on("click", function() {
        // $("#ribbon:hidden").slideToggle(500);
        $("#purchase-menu").slideToggle(500);
    })

    var multipleCardCarousel = document.querySelector("#testimonial-carousel");

    // var carouselWidth = $(".carousel-inner")[0].scrollWidth;
    // var cardWidth = $(".carousel-item").width();
    // var scrollPosition = 0;

    // $("#testimonial-carousel .carousel-control-next").on("click", function () {
    //     if (scrollPosition < carouselWidth - cardWidth * 4) {
    //         scrollPosition += cardWidth;
    //         $("#testimonial-carousel .carousel-inner").animate(
    //             { scrollLeft: scrollPosition },
    //             600
    //         );
    //     }
    // });

    // $("#testimonial-carousel .carousel-control-prev").on("click", function () {
    //     if (scrollPosition > 0) {
    //         scrollPosition -= cardWidth;
    //         $("#testimonial-carousel .carousel-inner").animate(
    //             { scrollLeft: scrollPosition },
    //             600
    //         );
    //     }
    // });

    // $("#testimonial-carousel .carousel-indicators button").on("click", function () {

    //     console.log($("#testimonial-carousel .carousel-inner .carousel-item.active").index())
    //     var to = $(this).data("bs-slide-to")

    //     $()

    //     $("#testimonial-carousel .carousel-inner").animate(
    //         { scrollLeft: scrollPosition },
    //         600
    //     );
    // });

    // // anchor nav compensation
    // var offset = $(':target').offset();
    // var scrollto = offset.top - 126; // minus fixed header height
    // $('html, body').animate({scrollTop:scrollto}, 0);

    $("*[data-scroll-to]").on("click", function(){

        let sectionOffset = $($(this).data("scroll-to")).offset().top

        let navHeight = $("nav.navbar").height() + $("#ribbon").height()

        $('html, body').animate(
            {scrollTop: sectionOffset - navHeight}, 
            100
        )

        $("#dropdown-button span").css("background-image", "url('http://"+window.location.host+"/wp-content/themes/itk-lws/images/Hamburger.svg')");

        $("#dropdown-menu").slideToggle(500)
    })

    function adjustTopMargin(){
        $(".head-banner").css("margin-top", $("nav.navbar").outerHeight() + "px")
    }

    function resize(){
        adjustTopMargin();

        if (window.matchMedia("(min-width: 1024px)").matches) {
            $(multipleCardCarousel).removeClass("slide");
        }else{
            $(multipleCardCarousel).addClass("slide");
        }

        if (window.matchMedia("(min-width: 576px)").matches){
            let container = $(".container");

            let margin = Number.parseFloat(container.css("margin-right").slice(0, -2));
            let padding = Number.parseFloat(container.css("padding-right").slice(0, -2));

            $("#dropdown-menu").css("right", margin + padding + "px")
        }else{
            $("#dropdown-menu").css("right", "0")
        }

    }

    //addEventListener("resize", resize)

    //resize()


    // Video
    $(document).on('shown.bs.modal','#videoModal', function () {
        $("#modal-video").get(0).load();
        $("#modal-video").get(0).play();
    });

    // When modal closes
    $('#videoModal').on('hidden.bs.modal', function (e) {
        $("#modal-video").get(0).pause();
    });

    $('#videoModal-india').on('hidden.bs.modal', function (e) {
        $("#video-india").attr('src', $("#video-india").attr('src'));
    });
    

    // When play button is clicked
    $("#playvideo").click(function(){
        $('#videoModal').modal('show');
    });

    $(document).on('shown.bs.modal','#showreelModal', function () {
        $("#showreel-video").get(0).load();
        $("#showreel-video").get(0).play();
    });

    // When modal closes
    $('#showreelModal').on('hidden.bs.modal', function (e) {
        $("#showreel-video").get(0).pause();
    });



    // form submission
    // $('body').on('submit', '#news-signup', function(e){
    //     e.preventDefault();

    //     $("#wdshFormResponse").empty();
    //     $("#wdsh-waiting").css('visibility','visible');
    //     $('#sendform').attr('disabled', 'disabled');
    //     $('form').bind('submit',function(e){e.preventDefault();});

    //     $.ajax({
    //         type: "POST",
    //         dataType: "json",
    //         url: 'ajax.php?a=fs',
    //         data: $("#missedForm").serialize(),
    //         success: function(data){
    //             if(data.error['ErrorStatus'] == 0){
    //                 $("#wdsh-waiting").css('visibility','hidden');
    //                 $("#wdshFormResponse").html(data.worksheetHTML);
    //                 $('#sendform').remove();
    //             }
    //             else{
    //                 showError(data.error['ErrorMessage']);
    //                 $("#wdsh-waiting").css('visibility','hidden');
    //                 if (data.error['ErrorStatus']=='76'){
    //                     $('#sendform').removeAttr('disabled', 'disabled');
    //                     $('form').unbind('submit');
    //                 }
    //             }
    //         }
    //     }); //Ajax
    // });

});